module.exports = __webpack_public_path__ + "img/L_321_0.c0271464.png";